import WriteToLog from "./WriteToLog";   

/**
 * Calculate Heart rate > 95th percentile for age
 * @param {*} heartrate of the patient
 * @param {*} age_exact_months
 * @returns 
 */
async function calculateHeartRate(heartrate, age_exact_months) {
  var shockHeartRateRisk = "none";
  var HRmax = "";

  try {
    if (age_exact_months >= 0 && age_exact_months < 3) {
      HRmax = 164;
    } else if (age_exact_months >= 3 && age_exact_months < 6) {
      HRmax = 159;
    } else if (age_exact_months >= 6 && age_exact_months < 9) {
      HRmax = 152;
    } else if (age_exact_months >= 9 && age_exact_months < 12) {
      HRmax = 145;
    } else if (age_exact_months >= 12 && age_exact_months < 18) {
      HRmax = 140;
    } else if (age_exact_months >= 18 && age_exact_months < 24) {
      HRmax = 135;
    } else if (age_exact_months >= 24 && age_exact_months < 36) {
      HRmax = 128;
    } else if (age_exact_months >= 36 && age_exact_months < 48) {
      HRmax = 123;
    } else if (age_exact_months >= 48 && age_exact_months < 72) {
      HRmax = 117;
    } else if (age_exact_months >= 72 && age_exact_months < 96) {
      HRmax = 111;
    } else if (age_exact_months >= 96 && age_exact_months < 144) {
      HRmax = 103;
    } else if (age_exact_months >= 144 && age_exact_months < 180) {
      HRmax = 96;
    } else if (age_exact_months >= 180 && age_exact_months < 216) {
      HRmax = 92;
    }

    if (HRmax !== "") {
      //var heartrate_number = heartrate.replace("/min", "");
      WriteToLog("HRmax: " + HRmax + " --- Patient HR: " + heartrate);
      if (heartrate > HRmax) {
        shockHeartRateRisk = "yes";
      }
    }
    WriteToLog("Inside calculateHeartRate: " + shockHeartRateRisk);
    return shockHeartRateRisk;
  } catch (error) {
    if (error.response) {
      WriteToLog("calculateHeartRate error.response: " + JSON.stringify(error.response.data));
      WriteToLog("calculateHeartRate error.response: " + JSON.stringify(error.response.status));
    } else if (error.request) {
      WriteToLog("calculateHeartRate error.request: " + error.request);
    } else {
      WriteToLog('calculateHeartRate Error ', error.message);
    }
    return shockHeartRateRisk;  
  }  
}

export default calculateHeartRate;
